import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class GlobalFileService {

    constructor(private http: HttpClient) { }

    upload(target: 'authenticator' | 'financial', key: string, file: File, cannedAcl: 'Private' | 'PublicRead' = 'Private'): Observable<any> {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('key', key);
        formData.append('cannedAcl', cannedAcl);
        return this.http.post(`api/${target}/file/upload`, formData, { responseType: 'text' });
    }

    download(target: 'authenticator' | 'financial', key: string): Observable<any> {
        const formData = new FormData();
        formData.append('key', key);
        return this.http.post(`api/${target}/file/download`, formData, {
            observe: 'response',
            responseType: 'blob' as 'json'
        });
    }

    delete(target: 'authenticator' | 'financial', key: string): Observable<any> {
        const formData = new FormData();
        formData.append('key', key);
        return this.http.post(`api/${target}/file/delete`, formData);
    }

}
